export function assertCurrentUser(): NonNullable<Window["currentUser"]> {
  if (!window.currentUser) {
    throw new Error("Expected window.current_user to be defined.");
  }
  return window.currentUser;
}
